import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Logout = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 4.6875 39.582031 L 4.6875 10.417969 C 4.6875 8.898438 5.292969 7.441406 6.367188 6.367188 C 7.441406 5.292969 8.898438 4.6875 10.417969 4.6875 L 18.75 4.6875 C 19.613281 4.6875 20.3125 5.386719 20.3125 6.25 C 20.3125 7.113281 19.613281 7.8125 18.75 7.8125 L 10.417969 7.8125 C 9.726562 7.8125 9.0625 8.085938 8.574219 8.574219 C 8.085938 9.0625 7.8125 9.726562 7.8125 10.417969 L 7.8125 39.582031 C 7.8125 40.273438 8.085938 40.9375 8.574219 41.425781 C 9.0625 41.914062 9.726562 42.1875 10.417969 42.1875 L 18.75 42.1875 C 19.613281 42.1875 20.3125 42.886719 20.3125 43.75 C 20.3125 44.613281 19.613281 45.3125 18.75 45.3125 L 10.417969 45.3125 C 8.898438 45.3125 7.441406 44.707031 6.367188 43.632812 C 5.292969 42.558594 4.6875 41.101562 4.6875 39.582031 Z M 32.230469 13.480469 C 32.800781 12.90625 33.707031 12.871094 34.320312 13.371094 L 34.4375 13.480469 L 44.855469 23.894531 C 45.464844 24.503906 45.464844 25.496094 44.855469 26.105469 L 34.4375 36.519531 C 33.828125 37.132812 32.839844 37.132812 32.230469 36.519531 C 31.617188 35.910156 31.617188 34.921875 32.230469 34.3125 L 39.976562 26.5625 L 18.75 26.5625 C 17.886719 26.5625 17.1875 25.863281 17.1875 25 C 17.1875 24.136719 17.886719 23.4375 18.75 23.4375 L 39.976562 23.4375 L 32.230469 15.6875 L 32.121094 15.570312 C 31.621094 14.957031 31.65625 14.050781 32.230469 13.480469 Z M 32.230469 13.480469 "
        fill={color}
      />
    </svg>
  )
}
